import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
    mailingFormWrapper: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',

        justifyContent: 'space-between',

        '@media (max-width: 769px)': {
            flexDirection: 'column',
        },
    },
    mailingFormWrapperHalf: {
        width: 'calc(50% - 10px)',

        '@media (max-width: 769px)': {
            width: '100%',
        },
    },
}))

const FormLayoutHalf = ({ leftHalf, rightHalf }) => {
    const classes = useStyles()
    return (
        <div className={classes.mailingFormWrapper}>
            <div className={classes.mailingFormWrapperHalf}>{leftHalf}</div>
            <div className={classes.mailingFormWrapperHalf}>{rightHalf}</div>
        </div>
    )
}

FormLayoutHalf.propTypes = {
    leftHalf: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.instanceOf(undefined),
    ]),
    rightHalf: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.instanceOf(undefined),
    ]),
}

export default FormLayoutHalf
